import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ArticleCard({ article, index = 0 }) {
  return (
    <Link
      to={`/journal/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${0.15 * index}s` }}
    >
      <div className="overflow-hidden rounded-2xl bg-secondary/40 aspect-[4/3]">
        <img
          src={article.image}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
        />
      </div>

      <div className="mt-6 flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-primary flex-wrap">
        <span>{article.category}</span>
        <span className="h-px w-6 bg-border hidden sm:inline-block" />
        <span className="text-muted-foreground">{article.read_time}</span>
        {article.audience && article.audience !== "All" && (
          <span className="ml-auto sm:ml-0 inline-flex items-center gap-2 text-accent-foreground/80 italic font-serif normal-case tracking-normal text-sm">
            <span className="h-px w-6 bg-border hidden sm:inline-block" />
            For {article.audience}
          </span>
        )}
      </div>

      <h3 className="mt-4 font-serif text-2xl sm:text-3xl font-light leading-tight text-foreground transition-colors duration-300 group-hover:text-primary">
        {article.title}
      </h3>

      <p className="mt-3 text-sm sm:text-base text-muted-foreground leading-relaxed line-clamp-3">
        {article.excerpt}
      </p>

      <span className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-foreground/70 group-hover:text-primary transition-colors">
        Read the essay
        <ArrowUpRight
          size={14}
          strokeWidth={1.5}
          className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </span>
    </Link>
  );
}
